import { AgGridReact } from "ag-grid-react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Common from "../../../Common";
import Header from "../../../Header";
import Back from "../../UI/Back";
import Message from "../../UI/Message";
import StatusCheckInput from "./StatusCheckInput";

export default class StatusWorkFlow extends Common {
  constructor(props) {
    super(props);
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      defaultColDef: {
        cellRenderer: (params) => {
          if (params.colDef.field !== "status") {
            return (
              <input
                type="checkbox"
                className="form-check-input text-center mt-2"
                onClick={(ev) => this.checkedHandler(params, ev)}
                checked={params.value}
              />
            );
          } else {
            return params.value;
          }
        },
      },

      rowData: [],
      columnDefs: [],
      frameworkComponents: {
        checkboxRenderer: StatusCheckInput,
      },
      createBoard: {
        board: false,
        title: "",
        message: "",
        position: "bottom-end",
        bg: "",
        code: "",
      },
      commondata: "",
    };
  }

  checkedHandler = async (params, ev) => {
    let checked = ev.target.checked;
    let colId = params.column.colId;
    params.node.setDataValue(colId, checked);
    const manageWorkflow = {
      workflow_id: Number(this.props.match.params.id),
      status_id: params.colDef.field,
      is_active: params.data[params.colDef.field] === true ? 1 : 0,
      parent_status_id: params.data.parent_status_id,
    };

    const response = await fetch(`${this.state.apiUrl}workflow/update-status`, {
      method: "post",
      body: JSON.stringify(manageWorkflow),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      this.setState({
        ...this.state,
        createBoard: {
          ...this.state.createBoard,
          board: true,
          message: rdata.message,
          title: rdata.status,
          bg: "primary",
        },
      });
    } else {
      this.setState({
        ...this.state,
        createBoard: {
          ...this.state.createBoard,
          board: true,
          message: rdata.message,
          title: rdata.status,
          bg: "danger",
        },
      });
    }
  };

  componentDidMount = async () => {
    const data = this.getCommonData();
    const response = await fetch(`${this.state.apiUrl}workflow/list-details`, {
      method: "post",
      body: JSON.stringify({
        workflow_id: this.props.match.params.id,
        attribute_set_key: this.props.match.params.attribute_set_key,
        app_token: data.app_token,
      }),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      const newcolumns = rdata.data.columns.map((item) => {
        if (item.field === "status") {
          return {
            ...item,
            headerName: "",
            lockPinned: true,
            suppressMenu: true,
            pinned: "left",
          };
        } else {
          return item;
        }
      });
      this.setState({
        ...this.state,
        rowData: rdata.data.rows,
        columnDefs: newcolumns,
      });
    }
  };
  onrowdragmove = async (ev) => {
    if (ev.source === "uiColumnDragged") {
      let attr_key = "";
      const {
        columnApi: {
          columnModel: { displayedTreeCentre },
        },
      } = ev;
      const newrr = [];
      const newrt = {};
      displayedTreeCentre.forEach((item, i) => {
        if (item.colDef.field !== undefined) {
          newrr.push(item.colDef.field);
        }
      });
      newrr.forEach((ii, i) => {
        newrt[ii] = i;
      });
      const orderinsequence = {
        workflow_id: this.props.match.params.id,
        status: { ...newrt },
      };
      const response = await fetch(`${this.state.apiUrl}workflow/sequence`, {
        method: "post",
        body: JSON.stringify(orderinsequence),
      });
      const rdata = await response.json();
      if (rdata.code === 200) {
        this.setState({
          ...this.state,
          createBoard: {
            ...this.state.createBoard,
            board: true,
            message: rdata.message,
            title: rdata.status,
            bg: "primary",
          },
        });
      } else {
        this.setState({
          ...this.state,
          createBoard: {
            ...this.state.createBoard,
            board: true,
            message: rdata.message,
            title: rdata.status,
            bg: "danger",
          },
        });
      }
    } else {
      return;
    }
  };
  render() {
    return (
      <>
        <Message board={this.state.createBoard} />
        <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
          <Header brecum_name="Add Listing" brecum_page={this.props?.title} />

          <Container fluid>
            <div className="page-content ">
              <p className="col-form-label txt-dark d-flex pb-0">
                <Back
                  name="Back"
                  to={`/tattle/${this.props.match.params.attribute_set_key}/settings`}
                  state={{ data: this.props.location.state }}
                  className="txt-dark underline-none"
                />
              </p>

              <Row className="mt-4">
                <Col md={12}>
                  <Card className="card cardTable">
                    <Card.Body>
                      <div class="pt-3 pb-3 ps-3 border-bottom">
                        <div class="row gx-2 justify-content-end align-items-center">
                          <div class="col">
                            <div class="title pe-1">Manage workflow</div>
                          </div>
                        </div>
                      </div>
                      <div class="card border-0 border-bottom">
                        <div class="card-body">
                          <div
                            style={{ height: "350px" }}
                            className="ag-theme-alpine ag-grid-head mt-3"
                          >
                            <AgGridReact
                              rowData={this.state.rowData}
                              columnDefs={this.state.columnDefs}
                              defaultColDef={this.state.defaultColDef}
                              onColumnMoved={this.onrowdragmove}
                              frameworkComponents={
                                this.state.frameworkComponents
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}
